import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'
Vue.use(Router)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Home',
      path: '/',
      component: require('../views/Home'),
      meta: { auth: true }
    },
    {
      name: 'Login',
      path: '/login',
      component: require('../views/auth/Login')
    },
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/goal-edit/:id',
      component: require('../views/editors/goal-edit')
    },
    {
      path: '/faceoff-edit/:id',
      component: require('../views/editors/faceoff-edit')
    },
    {
      path: '/player-edit/:id',
      component: require('../views/editors/player-edit')
    },
    {
      path: '/oddman-edit/:id',
      component: require('../views/editors/oddman-edit')
    },
    {
      path: '/hit-edit/:id',
      component: require('../views/editors/hit-edit')
    },
    {
      path: '/turnover-edit/:id',
      component: require('../views/editors/turnover-edit')
    },
    {
      path: '/time-on-ice-edit/:id',
      component: require('../views/editors/time-on-ice-edit')
    },
    {
      path: '/editors/season-totals/team-stats/:teamId',
      component: require('../views/season-totals/team-stats')
    },
    {
      path: '/game-editor/:gameId/:view',
      component: require('../views/editors/game-editor')
    },
    {
      path: '/teams/players/:teamId',
      component: require('../views/teams/players')
    },
    {
      path: '/editors/player-editor/:teamId',
      component: require('../views/editors/player-editor')
    },
    {
      path: '/editors/player-edit/:teamId/:playerId',
      component: require('../views/editors/player-edit')
    },
    {
      path: '/editors/player-add/:teamId/',
      component: require('../views/editors/player-add')
    },
    {
      path: '/Fixtures/game-night-live',
      component: require('../views/Fixtures/game-night-live')
    },
    {
      path: '/stats/match-stats/:gameId/:period',
      component: require('../views/stats/match-stats'),
      meta: { auth: true }
    },
    {
      path: '/stats/match-stats-short/:gameId/:period',
      component: require('../views/stats/match-stats-short'),
      meta: { auth: true }
    },
    {
      path: '/stats/match-stats-opposition/:gameId/:period',
      component: require('../views/stats/match-stats-opposition'),
      meta: { auth: true }
    },
    {
      path: '/stats/match-stats-test/:gameId/:period',
      component: require('../views/stats/match-stats-test'),
      meta: { auth: true }
    },
    {
      path: '/Fixtures/Season/18_19',
      component: require('../views/Fixtures/2018_2019_editor'),
      meta: { auth: true }
    },
    {
      path: '/stats/match-verifier/:gameId/',
      component: require('../views/stats/match-verifier'),
      meta: { auth: true }
    },
    {
      path: '/stats/player-equiv',
      component: require('../views/stats/player-equivalency'),
      meta: { auth: true }
    },
    {
      path: '/sandbox',
      component: require('../views/stats/sandbox')
    },
    {
      path: '/apps',
      component: require('../views/Apps/app-builds')
    },
    {
      path: '/season-stats/hits',
      component: require('../views/stats/season-stats/hits'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/turnovers',
      component: require('../views/stats/season-stats/turnovers'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/shots',
      component: require('../views/stats/season-stats/shots'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/faceoffs',
      component: require('../views/stats/season-stats/faceoffs'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/points',
      component: require('../views/stats/season-stats/points'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/overview',
      component: require('../views/stats/season-stats/overview'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/time-on-ice',
      component: require('../views/stats/season-stats/time-on-ice.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/shot-differentials',
      component: require('../views/stats/season-stats/shot-differentials.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/zone-entries',
      component: require('../views/stats/season-stats/zone-entries.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/zone-starts',
      component: require('../views/stats/season-stats/zone-starts.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/plus-minus',
      component: require('../views/stats/season-stats/plus-minus.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/penalty-minutes',
      component: require('../views/stats/season-stats/penalty-minutes.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/raw-data',
      component: require('../views/stats/season-stats/raw-data.vue'),
      meta: { auth: true }
    },
    {
      path: '/stats/match-verifier-official/:gameId',
      component: require('../views/stats/official-verifier.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/per-sixty',
      component: require('../views/stats/season-stats/per-sixty.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/player-stats/:player_id',
      component: require('../views/stats/season-stats/player-season-stats.vue'),
      meta: { auth: true }
    },
    {
      path: '/season-stats/vs-team',
      component: require('../views/stats/season-stats/vs_team.vue'),
      meta: { auth: true }
    },
    {
      path: '/stats/match-stats-22/:gameId/:period',
      component: require('../views/stats/match-stats-22.vue'),
      meta: { auth: true }
    },
    {
      path: '/stats/gb-toi/:gameId/:period',
      component: require('../views/stats/GB-TOI.vue'),
      meta: { auth: true }
    }
  ]
})

// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}



// WEBPACK FOOTER //
// ./client/router/index.js